import { lazy } from "react";

const BrandPage = lazy(() => import("../pages/brand/page"));

export const ALLOWED_BRAND_SLUGS = [
  "lg",
  "ge",
  "ge-profile",
  "sub-zero",
  "kitchenaid",
  "bosch",
  "samsung",
  "whirlpool",
  "frigidaire",
  "maytag",
  "miele",
  "kenmore",
  "electrolux",
  "amana",
  "summit",
] as const;

export type BrandSlug = (typeof ALLOWED_BRAND_SLUGS)[number];

const isBrandSlug = (value: string): value is BrandSlug => {
  return ALLOWED_BRAND_SLUGS.includes(value as BrandSlug);
};

export const loadBrandPage = (slug: string) => {
  if (!isBrandSlug(slug)) {
    return lazy(() => import("../pages/NotFound"));
  }

  return BrandPage;
};
